
import React from 'react';
import { Form, Input, InputNumber, Flex } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const t = {
    border: 'none',
    textAlign: 'left',
    fontWeight: 'normal',
}

export default ({defaultValue = {name: '', options: [{title: '', price: '', marketPrice: ''}]}, max = 6, value, onChange, id}) => {

    const [properties, setProperties] = React.useState(defaultValue.options);
    const [skuName, setSkuName] = React.useState('');

    React.useEffect(() => {
        if(defaultValue?.options) setProperties(defaultValue.options);

        if(value) {
            setProperties(value.options);
            setSkuName(value.name);
        }
    }, []);

    const addProperty = () => {
        const newProperties = [...properties, {title: '', price: '', marketPrice: ''}];
        setProperties(newProperties);
    }

    const onPropertiesChange = (position, index, e) => {

        const newProperties = properties.map((item, i) => {
            if(i === index) {
                if(position === 'title') {
                    return { ...item, title: e.target.value.trim() }
                } else if(position === 'price') {
                    return { ...item, price: e }
                } else if(position === 'marketPrice') {
                    return { ...item, marketPrice: e }
                }
            } else {
                return item;
            }
        });
        setProperties(newProperties);
        onChange?.({name: skuName, options: [...newProperties]});
    }

    const removeProperty = (index) => {
        const newProperties = properties.filter((item, i) => i !== index);
        setProperties(newProperties);
        onChange?.({name: skuName, options: [...newProperties]});
    }

    const onSkuNameChange = (value) => {
        setSkuName(value);
        onChange?.({name: value, options: properties});
    }

    return (
        <div id={id}>
            {/* <input value={value} type='hidden' /> */}
            <div>
                <Form.Item>
                    <Input placeholder="规格名称" value={skuName} onChange={(e) => onSkuNameChange(e.target.value)} style={{ width: '120px'}} />
                </Form.Item>
                <table style={{ width: '100%', maxWidth: '900px', border: 'none', borderSpacing: '5px'}}>
                    <thead>
                        <tr>
                            <th style={t}>规格值</th>
                            <th style={t}>价格(元)</th>
                            <th style={t}>市场价(元)</th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                            (properties || []).map(({title, price, marketPrice}, n) => {

                                return <tr gap={10} align='center' key={n}>
                                    <td style={t}>
                                        <Form.Item>
                                            <Input onChange={(e) => onPropertiesChange('title', n, e)} value={title} placeholder="型号/时长等" style={{ minWidth: '120px', width: '100%'}} />
                                        </Form.Item>
                                    </td>
                                    <td style={t}>
                                        <Form.Item>
                                            <InputNumber onChange={(e) => onPropertiesChange('price', n, e)} value={price} placeholder="售价" style={{width: '100%'}} />
                                        </Form.Item>
                                    </td>
                                    <td style={t}>
                                        <Form.Item>
                                            <InputNumber onChange={(e) => onPropertiesChange('marketPrice', n, e)} value={marketPrice} placeholder="市场价" style={{width: '100%'}} />
                                        </Form.Item>
                                    </td>
                                    <td style={t}>
                                        <Form.Item onClick={() => removeProperty(n)}>
                                            <DeleteOutlined style={{fontSize: 16}} />
                                        </Form.Item>
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            {properties && properties.length < max ? <a onClick={addProperty}>增加属性</a> : null}
        </div>
    );
}